import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import LinkedinSearchProjectItem from './linkedin-search-project-item';

interface Props {
  selectedUrls: string[];

  getProjectsUrls(): { strings: string[]; objectsAll: { url: string; keyword: string }[]; objectsDoubles: { url: string; keyword: string }[] };

  handleOpenProjectNameDialog(): void;

  handleSelectionChange(url: string): () => void;
}

const StepTwoUrlFinderProjects: React.FC<Props> = ({ selectedUrls, getProjectsUrls, handleOpenProjectNameDialog, handleSelectionChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const isSelected = (url: string) => {
    return selectedUrls.includes(url);
  };

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>{t('peopleFoundOnLinkedin')}:</Typography>
      <Typography className={classes.text}>{t('personaGeneratorUrlFinderProjectsText')}</Typography>
      <Stack className={classes.projects} direction={'column'}>
        {getProjectsUrls().objectsAll.map((result, index) => (
          <LinkedinSearchProjectItem
            key={index}
            result={result}
            isEven={index % 2 === 0}
            selected={isSelected(result.url)}
            handleSelectionChange={handleSelectionChange}
          />
        ))}
      </Stack>
      <div className={classes.buttonContainer}>
        <PaiButton text={t('createClassificationProject')} action={handleOpenProjectNameDialog} disabled={selectedUrls.length === 0} />
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    padding: '20px 16px',
    height: 'calc(100% - 39px - 16px - 20px)',
  },
  title: {
    fontSize: theme.typography.pxToRem(18),
    marginBottom: '16px',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    marginBottom: '16px',
  },
  projects: {
    border: `2px solid ${theme.palette.backgrounds.main}`,
    maxHeight: '425px',
    overflow: 'auto',
    overflowX: 'hidden',
  },
  cellTitle: {
    fontSize: theme.typography.pxToRem(12),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '24px',
  },
}));

export default StepTwoUrlFinderProjects;
